module.exports = __webpack_public_path__ + "img/nairam.c0b15549.jpg";